// en
export const timesheet = {
  prev_month: "<",
  next_month: ">",
  save: "Save",
  send_to_validator: "Send to validator",
  select_placeholder: "-- Select --",
  leave_paid: "Paid leave",
  leave_unpaid: "Unpaid leave",
  intern: "Intern",
  day: "Day",
  total: "Total",
  actions: "Actions",
  save_line: "Save",
  edit_line: "Edit",
  production: "Production",
  absences: "Absences",
  global_summary: "Global summary",
  total_days: "Total days",
  holidays: "Holidays",
  weekends: "Weekends",
  comments: "Comments",
  attachments: "Signed documents & attachments",
  upload_text: "Drop your files here or click",
  upload_hint: "(Max: 20 files of 15MB)",
  cra_saved: "CRA saved ✅",
  cra_save_error: "Error saving CRA ❌",
  email_sent_validator: "Email sent to validator ✅",
  email_send_error: "Error sending email ❌",
  write_comments: "Write your comments",
  loading: "Loading...",
  timesheets_title: "Timesheets",
  status_draft: "Draft",
  status_pending_validation: "Pending validation",
  status_validated: "Validated",
  status_refused: "Refused",
  status_pending: "⋯",
  period: "Period",
  state: "Status",
};
